export default "__VITE_ASSET__DDIMHHPC__"